module.exports = ".auto-login-full-size {\r\n    width: 100%;\r\n}\r\n.auto-login-card {\r\n    max-width: 258px;\r\n    margin: 90px auto;/*10% auto;*/\r\n}\r\n.auto-spinner {\r\n    margin-left: 220px;\r\n    margin-top: -38px; \r\n    float: none; \r\n    margin-bottom: 10px; \r\n}\r\n.mat-card-title {\r\n    width: 258px;\r\n    font-size: 22px;\r\n    margin-left: -10px;\r\n    margin-top: 0px; \r\n    margin-bottom: 30px; \r\n\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main